import { Ellipsis, Icon } from 'components/elements';
import { styled } from 'styles';
import { StyledTimelinePointIconProps } from './types';

export const TimelinePointBody = styled.div`
  display: flex;
  margin: ${({ theme }) => theme.spacing.absolute.small} 0;
`;

export const TimelinePointBodyContent = styled.div`
  margin-left: 1rem;
  padding-bottom: ${({ theme }) => theme.spacing.absolute.larger};
  white-space: pre-wrap;
`;

export const TimelinePointHeader = styled.div`
  align-items: center;
  display: flex;
  line-height: 1.5rem;
`;

export const TimelinePointIcon = styled(Icon)<StyledTimelinePointIconProps>`
  align-items: center;
  background-color: ${({ $color, theme }) => $color ?? theme.timeline.icon.background};
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.shadow.highlight};
  color: ${({ theme }) => theme.timeline.icon.color};
  display: flex;
  flex-shrink: 0;
  font-size: 1.2rem;
  height: 1.9rem;
  justify-content: center;
  margin-right: 1rem;
  opacity: 0.8;
  width: 1.9rem;
`;

export const TimelinePointLabel = styled.div`
  font-weight: 600;
  line-height: 1.2rem;
`;

export const TimelinePointLine = styled.div`
  background-color: ${({ theme }) => theme.timeline.line.color};
  border-radius: 0.2rem;
  margin-left: 0.85rem;
  margin-right: 0.85rem;
  min-width: 0.2rem;
  width: 0.2rem;
`;

export const TimelinePointTime = styled(Ellipsis)`
  color: ${({ theme }) => theme.timeline.time.color};
  flex: 1;
  line-height: 1.2rem;
  text-align: right;
`;

TimelinePointBody.displayName = 'TimelinePointBody';
TimelinePointBodyContent.displayName = 'TimelinePointBodyContent';
TimelinePointHeader.displayName = 'TimelinePointHeader';
TimelinePointIcon.displayName = 'TimelinePointIcon';
TimelinePointLabel.displayName = 'TimelinePointLabel';
TimelinePointLine.displayName = 'TimelinePointLine';
TimelinePointTime.displayName = 'TimelinePointTime';
